import React from 'react';
import Experience from '../../share/Experience/Experience';
import Review from '../../share/Review/Review';
import EventMini from '../EventMini/EventMini';
import OfferMini from '../OfferMini/OfferMini';
import OurTeam from '../OurTeam/OurTeam';
import WhyUs from '../WhyUs/WhyUs';
import HomeHeader from '../HomeHeader/HomeHeader';

const Home = () => {
    return (
        <div className="container">
            <HomeHeader/>
            <WhyUs/>
            <OfferMini/>
            <Experience/>
            <OurTeam/>
            <EventMini/>
            <Review/>
        </div>
    );
};

export default Home;